<script setup lang="ts">
import { watch } from 'vue'
import { RouterView } from 'vue-router'
import { useAuthStore } from '@/stores/auth'
import { useAppearanceStore } from '@/stores/appearance'

const auth = useAuthStore()
const appearance = useAppearanceStore()
watch(
  () => [auth.token, auth.authenticated] as const,
  ([token, authenticated]) =>
    void appearance.initialize(token, authenticated).catch(() => undefined),
  { immediate: true },
)
</script>

<template>
  <RouterView />
</template>
